export default {
  buttons: {
    create: 'Opret',
    update: 'Opdater',
    cancel: 'Annuller',
  },
  fields: {
    title: {
      label: 'Titel',
      placeholder: 'Indtast titel',
    },
    description: {
      label: 'Beskrivelse',
      placeholder: 'Indtast beskrivelse',
    },
    button_text: {
      label: 'Knaptekst',
      placeholder: 'Indtast knaptekst',
    },
    button_url: {
      label: 'Knap-URL',
      placeholder: 'https://example.com',
    },
    image: {
      label: 'Billede',
    },
  },
  title: 'Opret opslag',
};
